<template>
  <Page>
    <div class="page auditorium">
      <div class="top"></div>
      <div class="player">
        <div class="media">
          <div :class="['intro', 'overlay', introClass]" @click="hideOverlay">
            <Title
              title="Campus Complex"
              preheader="Welcome to the Archives of"
              shape="hexagon"
              labelLeft="Filmed in 2072"
              labelRight="Edited in 2022"
            ></Title>
            <div class="button-bg">
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="M16 8.26795C17.3333 9.03775 17.3333 10.9623 16 11.7321L4 18.6603C2.66667 19.4301 1 18.4678 1 16.9282L1 3.0718C1 1.5322 2.66667 0.569946 4 1.33975L16 8.26795Z"
                    fill="#807D79"
                  />
                </g>
              </svg>
              <p class="intro-play">Play Clips</p>
            </div>
          </div>

          <div :class="['choices', 'overlay', choicesClass]">
            <div class="choices-actions">
              <div @click="continuePlaying" class="button-bg">
                <p>Watch more Clips</p>
              </div>
              <div @click="headToTheory" class="button-bg">
                <p>Learn about Schoolscapes</p>
              </div>
            </div>
          </div>
          <div :class="['video-container', videoRoundedClass]">
            <video
              preload
              playsinline
              ref="videoPlayer"
              :key="activeSrc"
              @ended="ended"
              @canplay="canplay"
              @loadeddata="loadeddata"
              :src="activeSrc"
            >
              <source :src="activeSrc" />
            </video>
          </div>
        </div>
      </div>
      <div :class="['controls-container', controlsHiddenClass]">
        <div class="controls">
          <div @click="prevMedia" class="button-bg">
            <svg
              width="45"
              height="24"
              viewBox="0 0 45 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  d="M3.28125 10.2679C1.94792 11.0377 1.94792 12.9623 3.28125 13.7321L15.2812 20.6603C16.6146 21.4301 18.2812 20.4678 18.2812 18.9282L18.2812 5.0718C18.2812 3.5322 16.6146 2.56995 15.2812 3.33975L3.28125 10.2679Z"
                  fill="#807D79"
                />
              </g>
              <g>
                <path
                  d="M24 10.2679C22.6667 11.0377 22.6667 12.9623 24 13.7321L36 20.6603C37.3333 21.4301 39 20.4678 39 18.9282L39 5.0718C39 3.5322 37.3333 2.56995 36 3.33975L24 10.2679Z"
                  fill="#807D79"
                />
                <path
                  d="M24 10.2679C22.6667 11.0377 22.6667 12.9623 24 13.7321L36 20.6603C37.3333 21.4301 39 20.4678 39 18.9282L39 5.0718C39 3.5322 37.3333 2.56995 36 3.33975L24 10.2679Z"
                />
              </g>
            </svg>
          </div>
          <div @click="togglePlay" class="button-bg center-control">
            <svg
              v-if="playLabel == 'Play'"
              width="22"
              height="26"
              viewBox="0 0 22 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 11.268C22.3333 12.0378 22.3333 13.9623 21 14.7321L3 25.1244C1.66667 25.8942 3.33085e-07 24.9319 3.14725e-07 23.3923L6.68711e-08 2.60769C4.85115e-08 1.06809 1.66667 0.105845 3 0.875645L21 11.268Z"
                fill="#807D79"
              />
            </svg>
            <svg
              v-else-if="playLabel == 'Pause'"
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="8" height="24" rx="2.60881" fill="#807D79" />
              <rect x="13" width="8" height="24" rx="2.60881" fill="#807D79" />
            </svg>
          </div>
          <div @click="nextMedia" class="button-bg">
            <svg
              width="45"
              height="24"
              viewBox="0 0 45 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  d="M41.7187 10.2679C43.0521 11.0377 43.0521 12.9623 41.7187 13.7321L29.7188 20.6603C28.3854 21.4301 26.7188 20.4678 26.7188 18.9282L26.7188 5.0718C26.7188 3.5322 28.3854 2.56995 29.7188 3.33975L41.7187 10.2679Z"
                  fill="#807D79"
                />
                <path
                  d="M41.7187 10.2679C43.0521 11.0377 43.0521 12.9623 41.7187 13.7321L29.7188 20.6603C28.3854 21.4301 26.7188 20.4678 26.7188 18.9282L26.7188 5.0718C26.7188 3.5322 28.3854 2.56995 29.7188 3.33975L41.7187 10.2679Z"
                />
              </g>
              <g>
                <path
                  d="M21 10.2679C22.3333 11.0377 22.3333 12.9623 21 13.7321L9 20.6603C7.66667 21.4301 6 20.4678 6 18.9282L6 5.0718C6 3.5322 7.66667 2.56995 9 3.33975L21 10.2679Z"
                  fill="#807D79"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "@/components/Page.vue";
import Title from "@/components/Title.vue";

export default {
  name: "Auditorium",
  components: {
    Page,
    Title,
  },
  data() {
    return {
      videos: [
        "https://d1on0x8owq06rr.cloudfront.net/17b3e076d58fa3e89f8b53288a3381dd-On%20a%20Journey%20-%20Music%20Video.mp4",
        "https://d1on0x8owq06rr.cloudfront.net/94cbf6b2a02a07bcbb0b0cb325890b85-Autumn%20Archives%20-%20Shine%20the%20Light%20of%20Optimism.mp4",
        "https://d1on0x8owq06rr.cloudfront.net/991eb70cff3b6cc27efea73fc919ad78-Autumn%20Archives%20-%20Blocks%20of%20Curiosity.mp4",
        "https://d1on0x8owq06rr.cloudfront.net/cbf72533561ea93e50d57ea4722bbfeb-QC1%20-%20Peer%20Apprenticeships.mp4",
        "/figures/auditorium/cc-adventure-poems.mp4",
        "/figures/auditorium/cc-conference.mp4",
        "/figures/auditorium/cc-landmark.mp4",
        "/figures/auditorium/cc-printing.mp4",
        "/figures/auditorium/cc-train-01.mp4",
        "/figures/auditorium/cc-train-02.mp4",
        "/figures/auditorium/cc-train-03.mp4",
        "/figures/auditorium/cc-window.mp4",
        "/figures/auditorium/cc-workshop.mp4",
      ],
      mediaQueue: [],
      currentMedia: -1,
      isPlaying: false,
      introHidden: false,
      choicesHidden: true,
    };
  },
  computed: {
    playLabel() {
      return this.isPlaying ? "Pause" : "Play";
    },
    introClass() {
      return this.introHidden ? "overlay--is-hidden" : "";
    },
    videoRoundedClass() {
      return this.introHidden ? "" : "video--is-rounded";
    },
    controlsHiddenClass() {
      return this.introHidden ? "" : "controls--are-hidden";
    },
    choicesClass() {
      return this.choicesHidden ? "overlay--is-hidden" : "";
    },
    activeSrc() {
      return this.mediaQueue[this.currentMedia];
    },
  },
  methods: {
    hideOverlay() {
      this.introHidden = true;
      this.play();
    },
    togglePlay() {
      if (this.choicesHidden == false) {
        this.choicesHidden = true;
      }

      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        this.play();
      } else {
        this.pause();
      }
    },
    play() {
      this.$refs.videoPlayer.play();
      this.isPlaying = true;

      this.$store.dispatch("pauseSoundscape");
    },
    pause() {
      this.$refs.videoPlayer.pause();
    },
    pushToQueue(index = null) {
      if (this.videos.length > 0) {
        // get random video, remove from original array, and push to new array
        let num = this.getRandomInt(0, this.videos.length - 1);
        if (index != null) {
          num = index;
        }

        let newVideo = this.videos[num];
        this.videos.splice(num, 1);

        this.mediaQueue.push(newVideo);
        this.currentMedia++;
      } else {
        // no more videos, reload this.videos and reset currentMedia
        this.videos = this.mediaQueue;
        this.mediaQueue = [];
        this.currentMedia = -1;
        this.pushToQueue(0);
      }
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    prevMedia() {
      if (this.currentMedia != 0) {
        this.currentMedia--;
        this.play();
      } else if (this.currentMedia == 0) {
        this.$refs.videoPlayer.currentTime = 0;
        this.choicesHidden = true;
        this.play();
      }
    },
    nextMedia() {
      let playAfterAdd = false;
      if (this.currentMedia == 0) {
        this.choicesHidden = true;
        playAfterAdd = true;
      }

      this.pushToQueue();

      if (playAfterAdd) {
        this.play();
      }
    },
    loadeddata() {
      // console.log("loadeddata");
    },
    canplay() {
      if (this.isPlaying) {
        this.play();
      }
    },
    ended() {
      // Give option to continue or not
      if (this.mediaQueue.length === 1) {
        this.musicVideoEnded();
      } else {
        this.pushToQueue();
      }
    },
    musicVideoEnded() {
      this.choicesHidden = false;
      this.isPlaying = false;
    },
    continuePlaying() {
      this.pushToQueue();
      this.choicesHidden = true;
      this.play();
    },
    headToTheory() {
      // TODO: make this intercept the router
      let from = "/";
      let to = "/theory";

      this.$store.dispatch("playSoundscape");
      this.$store.dispatch("prepareToNavigate", {
        from,
        to,
        position: window.scrollY,
      });
      this.$router.push(to);
    },
  },
  mounted() {
    // append this so that the image preview and the loadeddata event work on mobile
    this.videos = this.videos.map((v) => v + "#t=0.001");
    this.pushToQueue(0);

    document.addEventListener("keyup", (e) => {
      let active = this.$route.path.replace("/", "");
      if (
        e.key == " " &&
        this.choicesHidden &&
        this.introHidden &&
        active == ""
      ) {
        this.togglePlay();
      }
    });
  },
  watch: {},
};
</script>

<style>
.auditorium {
  display: grid;
  grid-template-rows: 80px 1fr 140px;
}

.controls-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transform-origin: center center;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  opacity: 1;
  transform: translateY(0);
  transition-delay: 50ms;
}

.controls-container.controls--are-hidden {
  transform: translateY(-2.4rem);
  opacity: 0;
}

.controls {
  background: #FDF8F0;
  border: 1px solid #F0E0C7;
  box-shadow: 0px 2.39px 6.26px 1.39px rgba(114, 74, 13, 0.14), inset 0px 6.58286px 14.2629px 4.38857px rgba(255, 255, 255, 0.6);
  /* grid-gap: 24px; */
  display: flex;
  border-radius: 200px;
}

.controls .button-bg {
  box-shadow: none;
  border: none;
  border-radius: 0;
  background: none;
}

.player {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.player .title-container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.player .media {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 40px;
  max-width: calc((100vh - 80px - 140px) * (16 / 9));
}

.player .overlay {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 1000;
  transform-origin: center center;
  transition: all 150ms ease-in-out;
}

.player .overlay.overlay--is-hidden {
  opacity: 0;
  pointer-events: none;
}

.controls .center-control {
  min-height: 2.7rem;
  min-width: 2.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}


.button-bg {
  background: #FDF8F0;
  border: 1px solid #F0E0C7;
  box-shadow: 0px 2.39px 6.26px 1.39px rgba(114, 74, 13, 0.14), inset 0px 6.58286px 14.2629px 4.38857px rgba(255, 255, 255, 0.6);
  padding: 1.6rem 2.4rem;
  display: flex;
  align-items: center;
  grid-gap: 8px;
  transform-origin: center center;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  border-radius: 40px;
  cursor: pointer;
}

.button-bg svg {
  overflow: visible;
}

.button-bg p,
.button-bg svg path {
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  margin: 0;
  font-family: 'Scala';
  font-weight: bold;
  font-style: italic;
  color: #807D79;
}

.button-bg svg path,
.button-bg svg rect {
  filter: blur(0.05rem);
}


.intro:hover .button-bg p,
.button-bg:hover p {
  color: var(--red);
}

.intro:hover .button-bg svg path,
.intro:hover .button-bg svg rect,
.button-bg:hover svg path,
.button-bg:hover svg rect {
  fill: var(--red);
}

.intro:active .button-bg,
.button-bg:active {
  transform: scale(0.8);
}

.player .intro {
  background: radial-gradient(358.76% 358.76% at 50% 50%, var(--tan-01) 5.68%, rgba(253, 248, 240, 0) 100%);
  cursor: pointer;
}

.player .intro h1 {
  margin: 0;
}

.player .choices {
  
}

.choices .choices-actions {
  display: flex;
  flex-direction: row;
  grid-gap: 2.4rem;
  padding: 0 2rem;
  box-sizing: border-box;
  text-align: center;
}

.player .media .video-container {
  max-width: calc((100vh - 80px - 140px) * (16 / 9));
  width: 100%;
  padding-top: 56.25%;
  height: 0px;
  position: relative;
  background: var(--tan-02);
  border-radius: 12px;
  overflow: hidden;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.player .media .video-container.video--is-rounded {
  border-radius: 16rem;
}

.player .media video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

@media (max-width: 560px) {
  .player .media {
    padding: 0;
    max-width: calc((100vh - 0px - 140px) * (16 / 9));
  }
  .player .media .video-container {
    border-radius: 0;
    max-width: calc((100vh - 0px - 140px) * (16 / 9));
  }

  .intro-play {
    font-size: 2rem;
  }
}
</style>
